import { render, staticRenderFns } from "./jaundice.vue?vue&type=template&id=22c08606&scoped=true"
import script from "./jaundice.vue?vue&type=script&lang=js"
export * from "./jaundice.vue?vue&type=script&lang=js"
import style0 from "./jaundice.vue?vue&type=style&index=0&id=22c08606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c08606",
  null
  
)

export default component.exports